// modules
import { createAction } from 'redux-actions'

export const setActivityDashboardData = createAction(
  'SET_ACTIVITY_DASHBOARD_DATA'
)
export const setActivityDashboardStatistics = createAction(
  'SET_ACTIVITY_DASHBOARD_STATISTICS'
)

export const setActivityDashboardSummary = createAction(
  'SET_ACTIVITY_DASHBOARD_SUMMARY'
)
export const setActivityDashboardStatistic = createAction(
  'SET_ACTIVITY_DASHBOARD_STATISTIC'
)

export const setBillingCodes = createAction('SET_BILLING_CODES')
export const setActivityBillingStatistic = createAction(
  'SET_ACTIVITY_BILLING_STATISTIC'
)

export const setIsStatisticLoading = createAction('SET_IS_STATISTIC_LOADING')

export const setPredefinedActivityDashboardFilter = createAction(
  'SET_PREDEFINED_ACTIVITY_DASHBOARD_FILTER'
)

export const resetActivityDashboard = createAction('RESET_ACTIVITY_DASHBOARD')

export const setDashboardMeasurementList = createAction(
  'SET_DASHBOARD_MEASUREMENT_LIST'
)
